export default __webpack_public_path__ + "static/media/gallery449_3.9941aaef.png";